import { createThirdwebClient } from "thirdweb";
import { WalletProviderType } from "../services/enum/wallet-provider-type";
import {
  LAST_WALLET_USED_ADDRESS_KEY,
  WALLET_PROVIDER_KEY,
} from "@/app/consts/user";

export const isWeb3Auth = (walletProviderType: WalletProviderType) => {
  return walletProviderType === WalletProviderType.WEB3AUTH;
};

export const getStoredWalletData = () => {
  const walletProviderType = localStorage?.getItem(WALLET_PROVIDER_KEY);
  const walletAddress = localStorage?.getItem(LAST_WALLET_USED_ADDRESS_KEY);
  return {
    walletProviderType: walletProviderType || null,
    walletAddress: walletAddress || null,
  };
};

export const storeWalletData = (
  walletType: WalletProviderType,
  address: string
) => {
  localStorage.setItem(WALLET_PROVIDER_KEY, walletType);
  localStorage.setItem(LAST_WALLET_USED_ADDRESS_KEY, address);
};

export const clearWalletData = () => {
  localStorage.removeItem(WALLET_PROVIDER_KEY);
  localStorage.removeItem(LAST_WALLET_USED_ADDRESS_KEY);
};

export const client = createThirdwebClient({
  clientId: process.env.NEXT_PUBLIC_THIRD_WEB_CLIENT_ID ?? "",
});
